exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-testimonial{margin-bottom:50px}.Testimonial{background-color:#eee;padding-bottom:60px}.Testimonial .content-testimonial{text-align:left;border-top:2px solid #e0e0e0;padding-top:30px}.Testimonial .content-testimonial p.title-testimonial{font-size:20px;padding:20px 0}.Testimonial .content-testimonial p.sub-title-testimonial{font-size:16px;font-style:italic;line-height:25px}.Testimonial .content-testimonial p.signature{font-size:16px;font-weight:700;padding-top:20px;font-style:italic}@media (max-width:1024px){.Testimonial .container{max-width:100%;width:calc(100% - 30px);padding:0 15px}.Testimonial .container .content-testimonial{width:90%;margin:0 auto}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4db8918e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Testimonial.vue
// module id = 90
// module chunks = 0